{
  "eventDetails": "Event Details",
  "helpContentBodyText": "Displays the most recent 10 events reported by this device.\n\nView reports from different sensors by tapping/clicking them in Reporting Sensors.\n\nView older and more recent events by tapping/clicking 'older' and 'newer'.",
  "linkTo": "Events",
  "noDataForSensorWithSensorName": "No Data for {{sensorName}} sensor",
  "noOlderEventsFoundForThisDevice": "No older events found for this device.",
  "reportingSensors": "Reporting Sensors",
  "sensorReport": "{{sensorName}} Sensor Report",
  "subheader": "Click/Tap to inspect",
  "title": "Event History"
}
